import { render } from "./BrandExpress.vue?vue&type=template&id=76402226"
import script from "./BrandExpress.vue?vue&type=script&lang=ts"
export * from "./BrandExpress.vue?vue&type=script&lang=ts"

import "./BrandExpress.vue?vue&type=style&index=0&id=76402226&lang=scss"
script.render = render

export default script